export type TeamMemberId =
  | 'terrance'
  | 'razin'
  | 'darren'
  | 'anthony'
  | 'betty'
  | 'kevin'
  | 'chris'
  | 'jeffrey'
  | 'max'
  | 'peter'
  | 'alvin'
  | 'karl'
  | 'charlotte'
  | 'shawn'
  | 'alifah'
  | 'brienne'
  | 'kevinloo'
  | 'terence'
  | 'reyanna'
  | 'divya'
  | 'kk'
  | 'louis'
  | 'mark'
  | 'geena'
  | 'abram'
  | 'jake'
  | 'natalie'
  | 'alya'
  | 'markchau'

export type TeamMember = {
  id: TeamMemberId
  name: string
  position: string
  fullPosition: string
  job: string
  logo: string
  description: string
  linkedin?: string
  facebook?: string
  twitter?: string
  website?: string
}

export const teamMembers: TeamMember[] = [
  {
    name: 'Terrance Lok',
    position: 'Co-founder & CEO',
    fullPosition: 'Co-founder & Chief Executive Officer',
    job: 'Technical Engineer',
    id: 'terrance',
    logo: 'siemens',
    description: `Terrance is the Co-founder and Group CEO of TalentLabs. Previously, he was a venture capitalist at Horizons Ventures leading its investments into innovative companies such as Impossible Foods, Slack, and Zoom. His previous work experience includes working at ZWC Partners as Partner and Head of Southeast Asia, Barclays Capital as Derivatives Analyst, Citi as Institutional Sales, and Siemens as an engineer. Terrance was the recipient of the AmCham Charitable Foundation Scholar Award and is a member of Beta Gamma Sigma. Terrance was educated at Kellogg School of Management, HKUST and Queen's University.`,
    linkedin: 'https://www.linkedin.com/in/terrancelok/',
    twitter: 'https://twitter.com/LokTerrance',
    website: 'https://pitchbook.com/profiles/investor/133081-48'
  },
  {
    name: 'Razin Rozman',
    position: 'Co-founder & COO',
    fullPosition: 'Co-founder & Chief Operating Officer',
    job: 'Finance & Strategy',
    id: 'razin',
    logo: 'maxis',
    description: `Razin Ryan Rozman (“Ryan”) is the Co-Founder, Group President and Chief Operating Officer (COO) of TalentLabs, overseeing the Group's commercial and operational matters such as business development, corporate strategy, programme management, growth, product design, marketing, branding, human resources, and finance. 
    <br/><br/>
    Ryan was formerly the Chief Strategy Officer & Investment Director of MAVCAP, Malaysia's sovereign venture fund owned by Khazanah Nasional. Prior to MAVCAP, he was an Investment Manager at ZWC Partners, a Hong Kong growth investment firm that has invested in leading technology companies such as GoTo, Tantan, Boss Zhipin, Xpeng, and 4Paradigm. He was also attached to the Treasury & Corporate Finance Department of Maxis, in which he was tasked to craft key strategic initiatives in Corporate Development, Mergers & Acquisitions, Capital Fundraising and Restructuring.
    <br/><br/>
    Ryan graduated from King's College London & University of Cambridge, where he was a recipient of the Khazanah Cambridge Scholarship, the Cambridge Commonwealth Trust Scholarship, the Cambridge Judge Merit Scholarship and the Maxis Scholarship for Excellence Award.`,
    linkedin: 'https://www.linkedin.com/in/rznryan/',
    website: 'https://www.medium.com/@rznryan'
  },
  {
    name: 'Darren Chiu',
    position: 'Co-founder & CPO',
    fullPosition: 'Co-founder & Chief Product Officer',
    job: 'Technical Consultant',
    id: 'darren',
    logo: 'google',
    description: `Darren is the Co-founder & Chief Product Officer of TalentLabs, overseeing its product development, programme design and delivery, student learning, content development and academic operations. He was the Technical Solutions Architect and Product Lead at Google, focusing on machine learning and data solutions for digital marketing. Prior to Google, he helped develop trading systems for Morgan Stanley and Credit Suisse. 
    <br/><br/>
    Darren also has accumulated more than 10 years of experience in the education sector. He previously worked as a program leader and part-time lecturer for a technology business course in the Hong Kong University of Science & Technology (HKUST). Darren graduated from HKUST with a BEng. in Computer Engineering and also MA in Psychology from Chinese University of Hong Kong.`,
    linkedin: 'https://www.linkedin.com/in/darrenchiu/',
    website: 'https://medium.com/@darrenchiu'
  },
  {
    name: 'Anthony Chiu',
    position: 'Co-founder & CTO',
    fullPosition: 'Co-founder & Chief Technology Officer',
    job: 'Software Engineer',
    id: 'anthony',
    logo: 'clover',
    description: `Anthony is a Co-Founder & Chief Technology Officer of TalentLabs. He oversees the engineering, infrastructure, data and software development operations of the Company, enabling us to build a platform that operates at scale while advancing new products and technology through innovation. 
    <br/><br/>
    Prior to TalentLabs, he was a Software Engineer working at Clover Health, a health technology startup invested by Alphabet (Google). Anthony is responsible for web development and data applications in the company. Previously, he was the founder and CTO of Weava, a research productivity tool which has more than 250K users including from universities such as Yale University, Harvard University, MIT and many more. Outside of his working hours, Anthony is passionate about AI and data science - he is rated as “Kaggle Competitions Master” and ranked as the Top 1% Data Scientist globally. Anthony graduated from the University of Hong Kong with a BEng. in Computer Engineering and MSc. in Big Data Technology at the Hong Kong University of Science & Technology (HKUST).`,
    linkedin: 'https://www.linkedin.com/in/kingychiu/',
    website: 'https://www.kaggle.com/kingychiu'
  },
  {
    name: 'Prof. Betty Lin',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Professor',
    id: 'betty',
    logo: 'hkust',
    description:
      'Professor Betty is a veteran in the technology industry, having accumulated many years of work experiences across major global tech companies such as Agilent Technologies, Hewlett Packard (HP), Hyperion, Sun Microsystems and Akamai Technologies. Currently, she is managing an elite undergraduate program in Hong Kong University of Science and Technology (HKUST) which offers experiential learning courses such as Structured Problem- Solving and Design Thinking.',
    linkedin: 'https://www.linkedin.com/in/linbetty/',
    website: 'https://facultyprofiles.hkust.edu.hk/profiles.php?profile=betty-lin-bettylin'
  },
  {
    name: 'Kevin Lee',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Investment Partner',
    id: 'kevin',
    logo: 'l2',
    description:
      'Kevin is the Co-Founder & Partner of L2 Capital Management. He was previously an Investment Director in the VC arm of Gallant Investment Partners and was also appointed as the CEO of Genesis, a global gaming company. Prior to Gallant, Kevin was attached to Standard Chartered & Citi. Kevin graduated with a BS from the University of British Columbia, MFin with High Distinction from the University of Toronto, and MBA from the Kellogg School of Northwestern University. He is also a CFA and CPA (Canada).',
    linkedin: 'https://www.linkedin.com/in/kevin-lee-cfa-1012b8b/',
    twitter: 'https://twitter.com/klee_049',
    website: 'https://l2capm.com/team/kevin-lee/'
  },
  {
    name: 'Chris Lee',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Managing Director',
    id: 'chris',
    logo: 'clee',
    description:
      'Chris Lee is the Executive Director of Marga, covering North Asian investor relations and real estate operations in Myanmar. He also currently sits on the board of Grand Pagoda Ventures. Prior to joining Marga, he was at Ballingal Investment Advisors, a hedge fund focusing on long-short equity trades and PIPE transactions. He was previously attached to Standard Chartered covering Korean equity market and holds a B.S. in Finance from the University of Notre Dame.',
    linkedin: 'https://www.linkedin.com/in/chrischlee/',
    website:
      'https://apacentrepreneur.com/chris-lee-pioneering-the-future-in-real-estate-finance-and-beyond/'
  },
  {
    name: 'Jeffrey Tse',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Portfolio Manager',
    id: 'jeffrey',
    logo: 'barings',
    description: `Jeffrey is a Portfolio Manager of Barings' Multi Asset Group, based in Hong Kong. Jeffrey joined Barings in July 2021 and he is responsible for managing a range of Barings' multi-asset strategies in Asia. Prior to joining Barings, Jeffrey was a Portfolio Manager at Morgan Stanley for 5 years where he managed the Global Multi-Asset & Fixed Income discretionary strategies and was part of the Morgan Stanley Discretionary Portfolio Approval Committee. During his time at Morgan Stanley, he was responsible for global equity & credit research, portfolio construction, risk and duration management. Previously, Jeffrey was an analyst at HSBC Investment Banking Division. He was responsible for originating and executing M&A and capital markets (Equity & Debt) transactions in Asia ex-Japan. 
    <br/><br/>
    Jeffrey graduated with a Master in Aeronautical Engineering (1st class honours & Scholar of Aeronautics) from Imperial College London. He also won numerous nationwide awards in the UK, including Gold & Silver awards in the United Kingdom Mathematics & Physics Olympiad and top scorer (full marks) in UK A Level Mathematics. Jeffrey is fluent in Cantonese, English & Mandarin.`,
    linkedin: 'https://www.linkedin.com/in/jeffreytsecfa/',
    website: 'https://www.barings.com/en-us/institutional/about/team/jefffrey-tse'
  },
  {
    name: 'Max Lai',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Cyptocurrency Trader',
    id: 'max',
    logo: 'hashkey',
    description: `Max currently runs a cryptocurrency fund focused on quantitative strategies and DeFi yield farming. Prior to this, he was a cryptocurrency trader at Hashkey where he managed the firm's proprietary trading books. Before joining the cryptocurrency space, he was an equity derivatives trader at Optiver and Credit Suisse. Max holds a master's degree in Management Science and Engineering from Stanford University and a Bachelor's degree in Mathematics & Economics from UCLA.`,
    linkedin: 'https://www.linkedin.com/in/ysmlai/'
  },
  {
    name: 'Terence Ip',
    position: 'Advisor',
    fullPosition: 'Advisor',
    job: 'Senior Manager',
    id: 'terence',
    logo: 'aia',
    description: `Terence is an Advisor of TalentLabs and was a Senior Manager of People Analytics department at AIA. He is a business technologist and data expert with 17 years of experience in Business Transformation, Business Intelligence and Analytics. With strong global exposure and customer-facing skills, Terence has proven experience serving internal and external clients at all levels. Previously he had served at FedEx, Telstra, Deloitte Consulting, SAP and Microsoft.`,
    linkedin: 'https://www.linkedin.com/in/tsfip/'
  },
  {
    name: 'Shawn Yip',
    position: 'Senior Manager',
    fullPosition: 'Senior Manager',
    job: 'Product manager',
    id: 'shawn',
    logo: 'maxis',
    description: `Shawn is currently the Business Development Manager at TalentLabs. He is responsible in establishing relationship, building capabilities and delivering product solutions to serve government, state-owned enterprises and philanthropic organisations under his portfolio. In addition, he is tasked to oversee the stakeholder management, regulatory and corporate affairs for the company. 
    <br/><br/>
    Prior to TalentLabs, Shawn was a Product Manager and Academy Lead for Maxis eCommerce, in which he is responsible to educate and upskill entreprise clients on the business and technical aspects of running a successful eCommerce webstore. He has designed over 100 training modules and trained over 1,000 people on various eCommerce topics including campaign management, order management, digital marketing and many more.
    <br/><br/>
    Shawn is also a Trustee and Partnerships Director at the Digital Society Fund, a non-profit organisation advocating equal tech education opportunities for underserved communities.`,
    linkedin: 'https://www.linkedin.com/in/shawn-shakeif-yip-50398673/'
  },
  {
    name: 'Reyanna Ng',
    position: 'Manager',
    fullPosition: 'Manager',
    job: 'Manager',
    id: 'reyanna',
    logo: 'alchemist',
    description: `Reyanna is currently the Events & Community Management Lead. She is responsible to manage end-to-end event planning and execution for the company such as conferences, career fairs and many more. She is also tasked to grow and shape the TalentLabs tech talent community, leading our community engagement and community partnerships efforts, in line with the company's mission to build a truly integrated global tech talent platform. In addition, she is currently assisting the COO to build organisational capabilities across programme management, business development and account management functions. 
    <br/><br/>
    Previously, she was a Financial Journalist at The Edge Malaysia, where she was involved in formulating corporate news for the daily digital desk, and was a Copywriter at Amplify Studio, a boutique marketing agency based in the UK. Reyanna graduated from the University of Bristol with a degree in Sociology.`,
    linkedin: 'https://www.linkedin.com/in/reyanna-ng'
  },
  {
    name: 'Jake Tay',
    position: 'Manager',
    fullPosition: 'Manager',
    job: 'Manager',
    id: 'jake',
    logo: 'alchemist',
    description: `Jake Tay is a Business Development Manager at TalentLabs. He leads the execution of sales efforts targeting enterprise clients. He is responsible to drive sales growth, optimise revenue operations, accelerate business expansion and develop strategic business partnerships for the organisation. 
    <br/><br/>
    Prior to his current roles, Jake served as Senior Investment Associate at MAVCAP (now Jelawang Capital, a Khazanah subsidiary) and was seconded to Orbit Malaysia Fund, a joint-venture VC fund managed by Sunway Group & Kejora Capital . During his time at MAVCAP, he assisted in several strategic fund investments while also being actively involved in the ideation and execution of various ecosystem development initiatives. During his time at Orbit, he has successfully closed investments focusing on the healthcare and EV sectors. 
    <br/><br/>
    Throughout his career, Jake has facilitated startups in securing investments of US$700M from institutional investors, venture capital, and private equity funds, leveraging his extensive network within the startup and financial ecosystem.`,
    linkedin: 'https://www.linkedin.com/in/jaketay/'
  },
  {
    name: 'Alifah Arina',
    position: 'Manager',
    fullPosition: 'Manager',
    job: 'Architect',
    id: 'alifah',
    logo: 'riba',
    description: `Arina is an architecture graduate from the University of Bath. She is currently the Creative Manager for TalentLabs - where she is responsible to oversee the content creation and production of various TalentLabs brand assets such as film, animation, graphic design and illustration, landing pages and augmented reality. She also manage and develop all aspects of the company's brand identity and initiatives including launching campaigns to increase brand visibility and awareness. Our in-house expert in Adobe Creative Suites, Arina is highly proficient in Adobe Illustrator, Adobe Photoshop, Adobe Premiere Pro and many more. Her interests include designing for visual learners, AI algorithms, community building, and observing social trends.`,
    linkedin: 'https://www.linkedin.com/in/arina-khambari-003391147/'
  },
  {
    name: 'Brienne Lee',
    position: 'Manager',
    fullPosition: 'Manager',
    job: 'Consultant',
    id: 'brienne',
    logo: 'alchemist',
    description: `Brienne is currently the Strategy & Growth Manager of TalentLabs. She works closely with the Group President & COO in charting and developing the strategic direction for the company. She is responsible to drive corporate strategy, business growth, go-to-market initiatives, market expansion and optimising overall commercial operations. 
    <br/><br/>
    Prior to TalentLabs, she was an external consultant at The Alchemist Bar & Restaurant Group, a private equity-backed cocktail bar & restaurant chain based in the UK, and was involved in the international expansion project of the F&B establishments. Brienne holds a Master's degree in Business Analysis and Strategic Management from the University of Manchester and holds an LLB in Law from the University of Leeds.`,
    linkedin: 'https://www.linkedin.com/in/brienne-lee-9815b5141/'
  },
  {
    name: 'Abram Mah',
    position: 'Team Lead',
    fullPosition: 'Team Lead',
    job: 'Team Lead',
    id: 'abram',
    logo: 'alchemist',
    description: `Abram is a Team Lead with TalentLabs, functioning across multiple capacities including business development, project management, marketing, partnerships and corporate strategy.
    <br/><br/>
    An avid learner with a deep-seated interest for startups, Abram was previously a Regional Recruitment Consultant with Hyppies, focusing on senior to C-level hires within the Southeast Asia cybersecurity space. 
    <br/><br/>
    Abram graduated with a degree in Psychology from the University of Nottingham.`,
    linkedin: 'https://www.linkedin.com/in/xin-qi-abram-mah/'
  },
  {
    name: 'Gan Kian Kun',
    position: 'Software Engineer',
    fullPosition: 'Software Engineer',
    job: 'Software Engineer',
    id: 'kk',
    logo: 'alchemist',
    description: `KK is a versatile software engineer with a Bachelor's Degree in Engineering from Universiti Teknologi Malaysia (UTM). Leveraging her strong analytical and problem-solving skills, she seamlessly transitioned into software development. With expertise in Vue.js (Vue2 and Vue3), Nuxt.js, React.js, Django, Seo, Tailwind css, Sass, she has a proven track record of creating robust and efficient full-stack web applications. Her unique blend of engineering and software development skills enables her to deliver innovative solutions. Committed to continuous learning and passionate about integrating engineering principles with cutting-edge technology, she is always ready to tackle complex challenges and drive technological advancement.`,
    linkedin: 'https://www.linkedin.com/in/kian-kun-g-4920a1228/'
  },
  {
    name: 'Louis Lee',
    position: 'Software Engineer',
    fullPosition: 'Software Engineer',
    job: 'Software Engineer',
    id: 'louis',
    logo: 'alchemist',
    description: `Louis is a Software Engineer at TalentLabs, specializing in backend development. Initially starting with frontend development, Louis has transitioned to focus primarily on backend development. At TalentLabs, Louis excels in designing and implementing robust web applications, creating RESTful APIs, and managing databases, significantly enhancing application performance and user engagement. Louis holds a B.Eng (Honours) in Chemical Engineering from Universiti Tunku Abdul Rahman (UTAR), Foundation Certificate in Software Engineering and Certified Associate in Front-end Development from TalentLabs Academy.`,
    linkedin: 'https://www.linkedin.com/in/louis-lee-b8178b1b9'
  },
  {
    name: 'Natalie Ong',
    position: 'Management Associate',
    fullPosition: 'Management Associate',
    job: 'Management Associate',
    id: 'natalie',
    logo: 'alchemist',
    description: `Natalie is currently a Management Associate at TalentLabs, where she focuses on corporate growth, go-to-market initiatives, programme management and organisational development. She is also responsible for internal coordination and communication, assisting the Group President & COO in managing interdepartmental collaboration, streamlining operational matters and optimising organisational procedures to drive efficiency and performance.
    <br/><br/>
    She holds a degree in Psychology from Sunway University and previously worked as a Certified Behavior Technician at SEED Autism Services. With a clinical background in Applied Behavior Analysis (ABA), Natalie has cultivated strong problem-solving skills and a data-driven approach to optimizing outcomes. Now in the corporate sector, she leverages her analytical expertise and collaborative mindset to drive business growth and foster innovation across teams and projects.`,
    linkedin: 'https://www.linkedin.com/in/natalie-ong-840746213/'
  },
  //   {
  //     name: 'Mak Jien Hui',
  //     position: 'Management Associate',
  //     fullPosition: 'Management Associate',
  //     job: 'Management Associate',
  //     id: 'mark',
  //     logo: 'alchemist',
  //     description: `Mak is a Management Associate at TalentLabs. He is currently supporting various functions across TalentLabs, including Business Development, Research and Events Management. He is also responsible for collecting, processing, and performing statistical analyses on large datasets, including building business intelligence dashboards. His work also involves using various data analysis tools and methodologies to identify trends, patterns, and insights that can inform business decisions. Mak holds an Engineering degree from Universiti Tunku Abdul Rahman (UTAR).`,
  //     linkedin: 'https://www.linkedin.com/in/mak-jien-hui-380287216/'
  //   },
  {
    name: 'Divya Sivanandan',
    position: 'Management Associate',
    fullPosition: 'Management Associate',
    job: 'Management Associate',
    id: 'divya',
    logo: 'alchemist',
    description: `Divya is a Management Associate at TalentLabs, playing key roles across multiple core commercial functions such as strategy, operations, partnerships, and business development. She was previously a research assistant, at the Arkin Laboratory, where she conducted experiments and was required to carefully assess resources, methodological risks, and the imperative for precise outcomes to inform stakeholders. Divya graduated with a degree in Bioengineering from the University of California, Berkeley.`,
    linkedin: 'https://www.linkedin.com/in/divya-sivanandan'
  },
  {
    name: 'Mark Chau',
    position: 'Software Engineer',
    fullPosition: 'Software Engineer',
    job: 'Software Engineer',
    id: 'markchau',
    logo: 'crypto',
    description: `Mark is a Software Engineer at TalentLabs. He holds a Bachelor's Degree in Engineering (Computer Science) from The University of Hong Kong. He is an enthusiastic person and possesses a strong passion for exploring diverse technologies and subjects from multiple perspectives. With a robust background in software development and full-stack development, Mark is particularly passionate in exploring technologies such as Cloud Engineering, AI technologies, Machine Learning, Data Science and the latest advancements in Prompt Engineering.`,
    linkedin: 'https://www.linkedin.com/in/mark-chau-464720238/'
  },
  {
    name: 'Azreena Zin',
    position: 'Content Specialist',
    fullPosition: 'Content Specialist',
    job: 'Content Specialist',
    id: 'geena',
    logo: 'alchemist',
    description: `Azreena brings creativity and flair to TalentLabs as the Content Specialist, managing the company's dynamic online presence on Facebook, Instagram, TikTok, and newsletter. With a degree in English Language and Literature from the International Islamic University Malaysia, she skillfully crafts and schedules captivating content, from eye-catching posts to trendy TikTok videos. Passionate about blending the latest social media trends with TalentLabs' tech education niche, Azreena ensures the company brand stays fresh and engaging.`,
    linkedin: 'https://www.linkedin.com/in/azreenamdzin/'
  },
  {
    name: 'Alya Qistina',
    position: 'Marketing Associate',
    fullPosition: 'Marketing Associate',
    job: 'Marketing Associate',
    id: 'alya',
    logo: 'alchemist',
    description: `Alya Qistina is currently a Marketing Associate at TalentLabs. She is responsible to support the growth of the company's social media assets focusing on Instagram and TikTok. A graduate of Sultan Idris Education University with a degree in Social Communication, Alya brings a fresh perspective to digital marketing with her creative approach and communication skills. She creates and curates engaging content that resonates with TalentLabs' audience, blending current social media trends with useful insights to enhance TalentLabs' online presence.`,
    linkedin: 'https://www.linkedin.com/in/alya-qistina-j8201/'
  },
  {
    name: 'Kevin Loo',
    position: 'Instructor',
    fullPosition: 'Instructor',
    job: 'Director',
    id: 'kevinloo',
    logo: 'ideg',
    description: `Kevin Loo is the Director of Generation Enterprises Limited (GEL), a blockchain & crypto consultancy group and also the Managing Director, Head of Investment Insights at IDEG - an established international digital asset management leader. He currently oversees the firm's institutional asset management activities. Kevin has over 5 years' experience within the digital asset space, including being an early investor in Bitcoin since 2016. Additionally, he has worked with the largest and most recognized asset management companies, including PIMCO, Fidelity International, BNP Paribas, both in London and Hong Kong. He has experience of asset allocation, debt capital markets, focused on Global Bonds, Emerging Market Debt and Asia Credit. He has an established institutional track record of advising institutional clients, including pension funds, sovereign wealth funds, corporates and private bank asset allocator advisors. Previously, he been a mentor to the Cyberport Incubator Fund and, both personally and through partnerships, helped FinTech start-ups with strategic advisory, route-to-market and technology development reviews.`,
    linkedin: 'https://www.linkedin.com/in/kev-loo/'
  },
  {
    name: 'Peter Chow',
    position: 'Instructor',
    fullPosition: 'Instructor',
    job: 'Technical Engineer',
    id: 'peter',
    logo: 'google',
    description: `Peter is a Technical Solution Engineer at Google, specializing on Google Drive for enterprise-level customers. He graduated from the University of Hong Kong in 2017 majoring in Computer Engineering. Before Google, he worked in a number of startups & technology companies across different technical positions such as 9GAG, being the Web Engineer for one of the world's most famous social media & content site. With the experience acquired, he co-founded a startup named Gööp, a social app which became a hit among university students in Hong Kong.`,
    linkedin: 'https://www.linkedin.com/in/peteroid/'
  },
  //   {
  //     name: 'Alvin Wong',
  //     position: 'Teaching Assistant',
  //     fullPosition: 'Teaching Assistant',
  //     job: 'BSc. Computer Science',
  //     id: 'alvin',
  //     logo: 'hku',
  //     description: `Alvin Wong, from the University of Hong Kong (Department of Computer Science), is a passionate software engineer and technology educator. He is experienced not only in developing corporate systems, but also in educating the next generation of technology talents. He was appointed by Chinese University of Hong Kong as instructor for K-12 technology programmes, as well as leading commercial science and technology learning programmes in a government-incubated start-up, Pi Innovation Limited, in Hong Kong. Apart from lecturing, Alvin is also rich in practical technical experiences from developing multiple enterprise level software for education and sports sectors.`
  //   },
  {
    name: 'Charlotte Kwan',
    position: 'Instructor',
    fullPosition: 'Instructor',
    job: 'Full stack developer',
    id: 'charlotte',
    logo: 'prudential',
    description: `Charlotte is currently a Full Stack Developer at Prudential - one of the world's largest insurance and financial services company. She has extensive experiences in developing software applications from scratch using JavaScript, Python and Clojure frameworks and building multiple DevOps pipelines, data pipelines & cloud infrastructure. Charlotte graduated from the University of Michigan with a High Distinction and holds a master's degree in Economics from the Hong Kong University of Science & Technology (HKUST). She is also a Certified Microsoft Azure Solutions Architect Expert.`,
    linkedin: 'https://www.linkedin.com/in/charlottekwan/'
  },
  {
    name: 'Karl Wong',
    position: 'Instructor',
    fullPosition: 'Instructor',
    job: 'Data analytics specialist',
    id: 'karl',
    logo: 'crypto',
    description: `Karl is a Data Analytics Specialist at Crypto.com, one of the world's leading cryptocurrency wallet and exchange platform. He is responsible for the preparation and visualization of more than 5 million users of cryptocurrency exchange data - providing valuable growth insights and strategy to the company. Prior to Crypto.com, he was a Data Analyst at Nexmo, the Vonage API platform where he worked on various platform service quality improvements by deploying data driven quality measurement and automated test plans. Karl is well-versed in global telecommunication technologies and data - gained through his time at Hong Kong Telecom (HKT), one of Hong Kong's largest and premier telecommunications service provider. Karl graduated from City University of Hong Kong with a major in Information Engineering.`,
    linkedin: 'https://www.linkedin.com/in/karlwongyiucheung/'
  }
]
